import { render, staticRenderFns } from "./ActionButtonEmbed.vue?vue&type=template&id=b81f5604&"
import script from "./ActionButtonEmbed.vue?vue&type=script&lang=js&"
export * from "./ActionButtonEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports